import React, { Component } from "react";
import "./Title.scss";
import "./EffetTitle";

export default class Slider extends Component {
  render() {
    return (
      <div id="slider" className="d-flex justify-content-center text-center">
        <div className="heading">
          <h2 className="fullname">
            Alexandre Provost
          </h2>
          <h1 className="title-job">
            <span
            className="txt-rotate"
            data-period="1000"
            data-rotate='[ "Développeur Web Junior ReactJS / NodeJS" ]'
          />
          </h1>
          <button>
            <a href="#contact2">Contactez moi</a>
          </button>
        </div>
        <div className="slide1" />
      </div>
    );
  }
}
